import { BaseElement, BaseText, Descendant } from 'slate'

import { TranscriptParagraphContent } from 'src/models/Transcript'

export type SlateParagraph = BaseElement & {
    type: 'paragraph'
}

export type SlateParagraphContent = BaseText & {
    isEditable: boolean
    // Slate merges adjacent text nodes that share every property except `text`. A distinct key
    // keeps utterance runs apart, so the first keystroke cannot collapse them into one leaf.
    leafKey?: number
}

export const toSlateDescendant = (content: TranscriptParagraphContent[]): Descendant => ({
    type: 'paragraph',
    children: content.map((entry, index) => ({ ...entry, leafKey: index })),
})
